import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

export default function switchRenderer({ value, isOldValue }: RenderProps) {
  const boolValue = value === true || value === "true" || value === "yes";
  return (
    <ValueDisplay isOldValue={isOldValue}>
      {boolValue ? "Sí" : "No"}
    </ValueDisplay>
  );
}
